import React, { useContext, useEffect } from "react";
import TitleContext from "../../context/TitleContext";
import AllCompaniesComponent from "../../components/superAdmin/AllCompanies";
const AllCompaniesPage = () => {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("All Companies");
  }, [setTitle]);

  return (
    <>
      <AllCompaniesComponent />
    </>
  );
};
export default AllCompaniesPage;
